// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Breadcrumbs.css - Minor Adjustments for Alignment */
.breadcrumbs {
  font-size: 14px;
  text-align: right; /* Align breadcrumbs text to the right */
}

.breadcrumbs ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 4px; /* Adjust spacing between items */
}

.breadcrumbs li {
  display: flex;
  align-items: center;
}

.breadcrumbs a {
  color: #09111a;
  text-decoration: none;
}

.breadcrumbs a:hover {
  text-decoration: underline;
}

.breadcrumbs .separator {
  margin: 0 4px;
  color: #888;
}

.breadcrumbs .breadcrumb-active span {
  font-weight: normal;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Breadcrumbs.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,eAAe;EACf,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ,EAAE,iCAAiC;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* Breadcrumbs.css - Minor Adjustments for Alignment */\n.breadcrumbs {\n  font-size: 14px;\n  text-align: right; /* Align breadcrumbs text to the right */\n}\n\n.breadcrumbs ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  gap: 4px; /* Adjust spacing between items */\n}\n\n.breadcrumbs li {\n  display: flex;\n  align-items: center;\n}\n\n.breadcrumbs a {\n  color: #09111a;\n  text-decoration: none;\n}\n\n.breadcrumbs a:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbs .separator {\n  margin: 0 4px;\n  color: #888;\n}\n\n.breadcrumbs .breadcrumb-active span {\n  font-weight: normal;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
